// Vuex Authorization module

import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  userSession: {},
  errorData: {},
  loginToken: '',
};

const getters = {
  userSession: (state) => JSON.parse(JSON.stringify(state.userSession)),
  errorData: (state) => state.errorData,
  loginToken: (state) => state.loginToken,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;
